import React, { useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Knockout from '../../components/knockout';
import { Columns } from './data';
import { ApiClient } from '../../api';
import { ROUTES } from '../../router';
import KnockoutRoomDetailContainer, { KnockoutDetailRef } from './KnockoutRoomDetailContainer';

const KnockoutContainer = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState('');
    const detailRef = useRef<KnockoutDetailRef>(null);

    const { data, isFetching } = useQuery('knockouts', ApiClient.getKnockouts, {
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });

    async function onDelete() {
        console.log('delete call');
    }

    const onEdit = (id: string) => navigate(ROUTES.EDIT_KNOCKOUT.split(':').shift() + `${id}`);

    const onDetailClick = (record: any) => detailRef.current?.openModal(record);

    return (
        <>
            <Knockout
                search={search}
                setSearch={setSearch}
                data={data}
                loading={isFetching}
                columns={Columns(onDelete, onEdit, onDetailClick)}
            />
            <KnockoutRoomDetailContainer ref={detailRef} />
        </>
    );
};

export default KnockoutContainer;
